import type { Event } from 'hb-react/shared/apps/Events/components/EventCard/types';
import type {
  NetworkEvent,
  UserEvent,
} from 'hb-react/shared/apps/Events/components/EventsIndexContainer/components/types';

type IndexEventProps = NetworkEvent | UserEvent;

export const transformEventForCard = (event: IndexEventProps): Event => {
  const isUserEvent = event.organizer.type === 'User';
  const networkEvent = isUserEvent ? null : (event as NetworkEvent);

  const {
    locations,
    location,
    start_date_timestamp: startDateTimestamp,
    start_date: startDate,
    end_date_timestamp: endDateTimestamp,
    end_date: endDate,
  } = event;

  const firstLocation =
    location || (Array.isArray(locations) ? locations[0] : locations);

  return {
    cancelled: networkEvent?.cancelled || false,
    cancelledAt: networkEvent?.cancelled_at || null,
    coverPicture: event.new_cover_picture.preview_url,
    displayPriceTag: networkEvent?.display_price_tag || false,
    startDate: startDateTimestamp ?? startDate,
    endDate: endDateTimestamp ?? endDate,
    hasAttendees: event.has_attendees,
    id: event.id,
    networkCategories: networkEvent?.network_categories || [],
    participationType: networkEvent?.participation_type || 'no_participation',
    ticketsDueDate: networkEvent?.tickets_due_date,
    timezone: event.timezone,
    title: event.title,
    type: event.type,
    webinarUrl: networkEvent?.webinar_url,
    isInternalZoomMeeting: networkEvent?.is_internal_zoom_meeting,
    parent: {
      parentId: event.organizer.id || 0,
      parentType: event.organizer.type,
      name: event.organizer.name,
      avatarUrl: isUserEvent
        ? (event as UserEvent).new_organizer_logo?.medium_url
        : networkEvent?.organizer_logo_url,
    },
    location: firstLocation || {},
  };
};
